module.exports = __webpack_public_path__ + "img/logo-ct.cd73ca3b.png";